import {
  PrintStoreProductCategoriesListQuery,
  ProductCategoriesResponse,
  QueryPrintStoreProductCategoriesArgs
} from '@dtx-company/flow-codegen/src/code/generated.types'

export const getCategoriesListKey = (
  variables: QueryPrintStoreProductCategoriesArgs,
  pageIndex: number,
  previousPageData: PrintStoreProductCategoriesListQuery | null,
  token = ''
): string[] | null => {
  const variableField = variables.excludeChildCategories
    ? variables.excludeChildCategories.toString()
    : ''
  const key = pageIndex.toString()
  const pageInfo = previousPageData?.printStoreProductCategories?.paginationInfo
  if (previousPageData && !pageInfo?.hasNextPage) {
    return null
  }
  if (pageIndex === 0 || !pageInfo) {
    return [key, '', token, variableField]
  }

  return [key, pageInfo.endCursor ?? '', token, variableField]
}

export const reduceCategories = (
  data?: PrintStoreProductCategoriesListQuery[]
): ProductCategoriesResponse['productCategories'] | undefined => {
  if (!data) return
  return data?.reduce((prev, curr) => {
    const edges =
      curr?.printStoreProductCategories?.productCategories?.filter(
        edge => edge?.isTopLevelCategory
      ) ?? []
    return prev ? [...prev, ...edges] : [...edges]
  }, [] as ProductCategoriesResponse['productCategories'])
}

export const parseCategoriesListResponse = (
  data?: PrintStoreProductCategoriesListQuery[]
): {
  categories: ProductCategoriesResponse['productCategories'] | undefined
  pageInfo: ProductCategoriesResponse['paginationInfo'] | undefined
} => {
  const lastElement = data && data[data.length - 1]
  const pageInfo = lastElement?.printStoreProductCategories?.paginationInfo
  const categories = reduceCategories(data)
  return {
    categories,
    pageInfo
  }
}
